export enum MolTableActionTypeEnum {
  PRIMARY = "primary",
  DANGER = "danger",
}
